import { isEveningBriefing } from './currentTimeCheckUtils';
import { CMMID_EVENING_BRIEFING, CMMID_MORNING_BRIEFING } from './constants';

/**
 * Helper function to determine which inbox briefing CMMID to use based on current time
 * @param useForceWindow - When true, uses the wider force window for time checks. Must match the
 * window used to determine the displayed briefing so the CMMID correlates to the correct briefing.
 */
export function getCMMIDForInboxBriefing(useForceWindow?: boolean): string {
    // Default to morning briefing CMMID for any other time
    return isEveningBriefing(useForceWindow) ? CMMID_EVENING_BRIEFING : CMMID_MORNING_BRIEFING;
}
